import { render } from "./TheApproach.vue?vue&type=template&id=4ef666f2&scoped=true"
const script = {}

import "./TheApproach.vue?vue&type=style&index=0&id=4ef666f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef666f2"]])

export default __exports__